
export function imageToBase64(imagePath) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);
      const ext = (imagePath.split(".").pop() || "").toLowerCase();
      let mimeType = "image/png";
      let quality = undefined;
      if (ext === "jpg" || ext === "jpeg") {
        mimeType = "image/jpeg";
        quality = 0.92;
      } else if (ext === "webp") {
        mimeType = "image/webp";
        quality = 0.92;
      }
      const base64 = canvas.toDataURL(mimeType, quality);
      console.log("✅ 图片转换成功");
      resolve(base64);
    };

    img.onerror = function () {
      console.error("❌ 图片加载失败:", imagePath);
      resolve("");
    };

    img.src = imagePath;
  });
}


function base64DataURLToArrayBuffer(dataURL) {
  const base64Regex = /^data:image\/(png|jpg|jpeg|svg|svg\+xml);base64,/;
  if (!base64Regex.test(dataURL)) {
    return false;
  }
  const stringBase64 = dataURL.replace(base64Regex, "");

  let binaryString;
  if (typeof window !== "undefined") {
    binaryString = window.atob(stringBase64);
  } else {
    binaryString = Buffer.from(stringBase64, "base64").toString("binary");
  }

  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes.buffer;
}

/**
 * 导出word文档（带图片）
 *
 */
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
// @ts-nocheck
import ImageModule from 'docxtemplater-image-module-free';

// 导出工单数据到 Word
export const exportWorkOrdersToWord = async (workOrders) => {
  const templatePath = "/templates/workOrderTemplate.docx";
  const fileName = `工单信息表_${new Date().getTime()}.docx`;
  
  const data = {
    workOrders: workOrders
  };
  
  return generateDocx(templatePath, data, fileName);
};

export const generateDocx = async (
  tempDocxPath,
  data,
  fileName
) => {
  return new Promise((resolve, reject) => {
  if (!fileName.toLowerCase().endsWith(".docx")) {
    fileName = fileName + ".docx";
  }

  JSZipUtils.getBinaryContent(tempDocxPath, async(error, content) => {
    if (error) {
      console.error("模板加载失败:", error);
      reject(error);
      return;
    }

    let opts = {};
    opts = {
      centered: false,
    };
    opts.getImage = (chartId) => {
       return base64DataURLToArrayBuffer(chartId);
    };

    opts.getSize = function (img, tagValue, tagName) {
      if (tagName == "echartUrl") {
        return [600, 600];
      } else if (tagName == "pictureUrl" || tagName == "photoUrl") {
        return [250, 200];
      } else if (tagName == "NopictureUrl") {
        return [180, 156];
      }
      return [600, 400];
    };

    const zip = new PizZip(content);
    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
      modules: [new ImageModule(opts)],
      nullGetter: function () {
        return "/";
      },
    });

    doc.setData(data);
    
    try {
      doc.render();
    } catch (error) {
      const e = {
        message: error.message,
        name: error.name,
        stack: error.stack,
        properties: error.properties,
      };
      console.error("文档渲染失败:", e);
      reject(error);
      return;
    }

    const out = doc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    saveAs(out, fileName);
    console.log("✅ Word 文档生成成功:", fileName);
    resolve(true);
  });
  });

  
};
